import { render, staticRenderFns } from "./scroll-area.vue?vue&type=template&id=ef25591a&"
import script from "./scroll-area.vue?vue&type=script&lang=ts&"
export * from "./scroll-area.vue?vue&type=script&lang=ts&"
import style0 from "./scroll-area.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports